/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcQuotemediaV1EodPriceJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_QUOTEMEDIA_V1_EOD_PRICE_JOB_EVENT_ENTITY_NAME = 'exc.quotemedia.v1.EodPriceJobEvent';
export const excQuotemediaV1EodPriceJobEventEntity = new schema.Entity<ExcQuotemediaV1EodPriceJobEvent>(EXC_QUOTEMEDIA_V1_EOD_PRICE_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcQuotemediaV1EodPriceJobEvent) => `${entity.metadata?.eventId}` });

